/* eslint-disable max-len */
import { Box, Typography } from "@mui/material";
import React from "react";
import { StyledBookingFlowButton } from "../../containers/BookingScheduleContainer/BookingScheduleContainer.style";
import { WellnessSuccessAvatar, Loading } from "../../../components";
import { usePetStore } from "../../../hooks/redux-hooks/pet-store/pet-store.service";
import { useModal } from "../../../context/ModalContext";
import { userActivityLogger } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { fromISOToFormatDatePlusDays } from "../../../utils/unix-timestamp";
import { useNavigate } from "react-router-dom";
import { PAGES_PATH } from "../../../navigation/params";
import { useGetAutoRenewalPreference } from "../../../services/renewal-preference/renewal-preference.service";

// TODO(wellness-renewal): update preference-save success modal copy once design copy is provided
const WellnessPlanTransitionSuccessModal = () => {
  const { petList } = usePetStore();
  const navigate = useNavigate();
  const { closeModal, params } = useModal();

  // Get currentSubscriptionId from params
  const currentSubscriptionId = params.currentSubscriptionId as string;

  // Fetch the preference data
  const { preference, loading } = useGetAutoRenewalPreference(currentSubscriptionId);

  // Get pet details from the preference
  const currentPet = petList?.filter((pet) => pet.id === preference?.animalId);

  // Get plan details from the preference
  const planName = preference?.newPlanName;
  const planStartDate = preference?.newPlanStartDate;

  // Helper function to format ISO date string (plan starts the day after the current plan ends)
  const formatPlanStartDate = (dateString?: string) => {
    if (!dateString) return "soon";

    return fromISOToFormatDatePlusDays(dateString, 1);
  };

  const handleClose = () => {
    if (currentPet && currentPet[0]) {
      userActivityLogger(MIXPANEL_EVENTS.USER_CLICK_GOT_IT_IN_POPUP,
        {
          popup_type: "goodpet_to_totalcare_transition",
          plan_name: planName,
          pet_name: currentPet[0].name,
        });
    }
    closeModal();
    navigate(PAGES_PATH.USER_PROFILE+"/"+PAGES_PATH.USER_BILLING);
  };

  // Show loading state
  if (loading || !preference) {
    return (
      <Box className="bg-white flex flex-col justify-center items-center gap-5 w-full xl:w-[25rem] p-8">
        <Loading />
      </Box>
    );
  }

  return (
    <>
      <Box className="bg-white flex flex-col justify-center items-center gap-5 w-full xl:w-[25rem]">
        <Box className="flex justify-between w-full relative -top-3 -right-2">
          <div></div>
        </Box>
        {currentPet && currentPet[0] && <WellnessSuccessAvatar image={currentPet[0]?.image} name={currentPet[0].name} />}
        <Typography
          textAlign={"center"}
          variant="h2"
          className="!font-semibold"
        >
          Woohoo! <span className="capitalize">{currentPet && currentPet[0]?.name}</span> is on the <br />
          {planName}
        </Typography>
        <Typography textAlign={"center"} className="bg-gray-2 shadow-sm p-1 flex justify-center tracking-wide md:px-16">
          We&apos;ve sent you a confirmation email
        </Typography>
        <Typography textAlign={"center"} className="!w-full !mb-2" variant="body1">
          <span className="capitalize">{currentPet && currentPet[0]?.name}</span>&apos;s{" "}
          {planName} starts {formatPlanStartDate(planStartDate)}. Your card will be charged on the plan start date.
        </Typography>
        <StyledBookingFlowButton
          fullWidth
          color="primary"
          size="small"
          className="!sticky !bottom-3"
          onClick={handleClose}
        >
          Got it
        </StyledBookingFlowButton>
      </Box>
    </>
  );
};

export default WellnessPlanTransitionSuccessModal;

